module.exports = __webpack_public_path__ + "static/img/hjjc.6c83acd0.png";